<template>
    <div>
        <legend>Заказы</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="false"
        >
            <dx-editing
                    :allow-updating="false"
                    :allow-deleting="false"
                    :allow-adding="false"
                    mode="row"
            />
            <dx-column
                    data-field="SferaNumber"
                    caption="Номер Сферы"
            />
            <dx-column
                    data-field="LocalNumber"
                    caption="Локальный номер"
            />
            <dx-column
                    data-field="Name"
                    caption="Наименование"
            />
            <dx-column
                    data-field="Customer.Login"
                    caption="Клиент"
            />
            <dx-column
                    data-field="Customer.Reception"
                    caption="Приемный пункт"
            />
            <dx-column
                    data-field="Summary"
                    caption="Цена"
            />
            <dx-column
                    data-field="Amount"
                    caption="Количество"
            />
            <dx-column
                    data-field="Summary"
                    caption="Итого"
            />
            <dx-column
                    data-field="Comment"
                    caption="Комментарий"
            />
            <dx-column
                    data-field="DispatchDate"
                    caption="Дата отправки"
            />
            <!--      <dx-column-->
            <!--        data-field="PartnerId"-->
            <!--        caption="Партнер"-->
            <!--      >-->
            <!--        <dx-lookup-->
            <!--          :data-source="partnerData"-->
            <!--          value-expr="Id"-->
            <!--          display-expr="Reception"-->
            <!--        />-->
            <!--      </dx-column>-->
<!--            <dx-column-->
<!--                    data-field="Customer.TourId"-->
<!--                    caption="Объезд"-->
<!--            >-->
<!--                <dx-lookup-->
<!--                        :data-source="partnerTourData"-->
<!--                        value-expr="Id"-->
<!--                        display-expr="Name"-->
<!--                />-->
<!--            </dx-column>-->
            <dx-column
                    data-field="OrderStatusId"
                    caption="Статус"
            >
                <dx-lookup
                        :data-source="statusData"
                        value-expr="Id"
                        display-expr="Name"
                />
            </dx-column>
        </dx-data-grid>
    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
  DxColumn, DxDataGrid, DxEditing, DxLookup, DxPaging,
} from 'devextreme-vue/data-grid';
import token from '@/admin/services/token';

const url = `${process.env.VUE_APP_API_HOST}admin/dispatch`;
const dataSource = createStore({
  key: 'Id',
  loadUrl: `${url}/late-orders/in_dispatch/today`,
  // insertUrl: `${url}/insert`,
  // updateUrl: `${url}/update`,
  // deleteUrl: `${url}/delete`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
});

// const partnerTourData = createStore({
//   key: 'Id',
//   loadUrl: `${process.env.VUE_APP_API_HOST}admin/tour`,
//   onBeforeSend(operation, ajaxOptions) {
//     ajaxOptions.headers = {
//       Authorization: `Bearer ${token}`,
//     };
//   },
// });
const statusData = createStore({
  key: 'Id',
  loadUrl: `${process.env.VUE_APP_API_HOST}admin/order-status`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
      DxPaging,
  },
  data() {
    return {
      dataSource,
      // partnerTourData,
      statusData,
    };
  },
};
</script>
